import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/layouts/default.vue").then(m => m.default || m)),
  main: defineAsyncComponent(() => import("/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/packages/support-pc/layouts/main.vue").then(m => m.default || m)),
  "svg-sprite": defineAsyncComponent(() => import("#build/svg-sprite.vue").then(m => m.default || m))
}